
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const ContributionFootnote: React.FC = () => {
  const isMobile = useIsMobile();
  return <div className="bg-sky-50 p-3 md:p-4 rounded-lg border border-sky-100 mt-4">
      <p className={`text-sky-800 ${isMobile ? 'text-xs' : 'text-sm'} flex justify-center items-center`}>
        <span className="text-center">
          Đóng góp thêm nhằm hỗ trợ chi phí tổ chức buổi họp mặt và chương trình chăm sóc sức khoẻ thầy cô. 
          <span className="block mt-1 text-center">Xin chân thành cảm ơn!</span>
        </span>
      </p>
    </div>;
};
export default ContributionFootnote;
